import { connect } from 'react-redux';
import { standardInstrumentsWithProductFullNamesAndProductSymbols } from 'apex-web/lib/redux/selectors/instrumentPositionSelectors';
import { selectInstrument } from 'apex-web/lib/redux/actions/instrumentActions';
import { getProductAttributes } from 'apex-web/lib/redux/actions/productActions';
import { unsubscribeLevel2 } from 'apex-web/lib/redux/actions/level2Actions';
import get from 'lodash/get';
import { digitalAssetsListSelector } from 'apex-web/lib/redux/selectors/digitalAssetsSelectors';
import DigitalAssetsPage from './DigitalAssetsPage';

const mapStateToProps = state => {
  return {
    instruments: standardInstrumentsWithProductFullNamesAndProductSymbols(state),
    selectedInstrument: state.apexCore.instrument.selectedInstrumentId,
    products: get(state, 'apexCore.product.products', []),
    productAttributes: get(state, 'productAttributes', {}),
    digitalAssets: digitalAssetsListSelector(state)
  };
};

const mapDispatchToProps = dispatch => ({
  getProductAttributes: payload => dispatch(getProductAttributes(payload)),
  selectInstrument: payload => dispatch(selectInstrument(parseInt(payload, 10))),
  unsubscribeLevel2: instrumentId => dispatch(unsubscribeLevel2(instrumentId))
});

export default connect(mapStateToProps, mapDispatchToProps)(DigitalAssetsPage);
